import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from '@cloudez/cloudez-design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import ReactLoading from 'react-loading';

import { useDocTitle } from 'hooks/docTitle';
import { useLayout } from 'hooks/layout';
import { verifyEmailService } from 'services/auth';
import { Card, Content, Wrapper } from './styles';

const ConfirmEmail: React.FC = () => {
  const theme = useLayout();
  const history = useHistory();
  const { key } = useParams<{ key: string }>();

  // loading, success ou error
  const [status, setStatus] = useState('loading');

  useDocTitle(`Confirmação de e-mail — ${theme.name}`);

  useEffect(() => {
    verifyEmailService(key)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [key]);

  return (
    <Wrapper>
      <Content>
        {!theme || theme.loading ? (
          <ReactLoading type="balls" />
        ) : (
          <>
            <img src={theme.logo_primary} alt="logo" />
            <Card>
              {status === 'loading' && (
                <>
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    size="3x"
                    style={{
                      color: theme.darkMode
                        ? theme.interface5
                        : theme.interface7,
                    }}
                  />
                  <h3>Confirmando seu e-mail...</h3>
                </>
              )}

              {status === 'success' && (
                <>
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    size="3x"
                    style={{ color: theme.success }}
                  />
                  <h3>E-mail confirmado!</h3>
                  <p>Agora é só entrar com o seu e-mail e senha.</p>
                </>
              )}

              {status === 'error' && (
                <>
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    size="3x"
                    style={{ color: theme.error }}
                  />
                  <h3>Link inválido ou expirado</h3>
                  <p>
                    Tente entrar com o seu e-mail e senha. Se o e-mail ainda não
                    estiver confirmado, você poderá pedir um novo link.
                  </p>
                </>
              )}

              {status !== 'loading' && (
                <Button
                  width="100%"
                  height="50px"
                  type="button"
                  onClick={() => history.push('/login')}
                >
                  Ir para o login
                </Button>
              )}
            </Card>
          </>
        )}
      </Content>
    </Wrapper>
  );
};

export default ConfirmEmail;
